export interface IMetaLeadEventIdComponentsInput {
  legacyCustomerId: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

const normaliseMetaLeadEventIdComponent = (
  value: string | null | undefined,
): string => value?.toLowerCase().trim() ?? "";

export function buildMetaLeadEventIdComponents({
  legacyCustomerId,
  email,
  firstName,
  lastName,
}: IMetaLeadEventIdComponentsInput): string {
  return legacyCustomerId
    + normaliseMetaLeadEventIdComponent(email)
    + normaliseMetaLeadEventIdComponent(firstName)
    + normaliseMetaLeadEventIdComponent(lastName);
}
